import React, { useState, useEffect } from 'react';
import './Reads.css';
import { fetchReads } from '../utils/api';
import { formatContentDate } from '../utils/date';

const Reads = () => {
  const [reads, setReads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadReads = async () => {
      try {
        const data = await fetchReads({ signal: controller.signal });
        setReads(data);
      } catch (err) {
        if (err.name !== 'AbortError') {
          setError(err.message);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    loadReads();

    return () => controller.abort();
  }, []);

  return (
    <>
      <h2 className="section-header">Reads</h2>
      {loading ? (
        <div className="content-item status-message" role="status" aria-live="polite">
          Loading reading list…
        </div>
      ) : error ? (
        <div className="content-item status-message" role="alert">
          Unable to load the reading list: {error}
        </div>
      ) : reads.length === 0 ? (
        <div className="content-item status-message" role="status">
          No reading-list entries are available yet.
        </div>
      ) : (
        <ul className="reads-list" aria-label="Reading list">
          {reads.map((read) => (
            <li key={read.id} className="reads-list-item">
              {read.url ? (
                <a
                  href={read.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="reads-title-link"
                >
                  {read.title}
                  <span className="visually-hidden"> (opens in a new tab)</span>
                </a>
              ) : (
                <span className="reads-title">{read.title}</span>
              )}
              {(read.author || read.publication || read.date) && (
                <p className="reads-meta">
                  {read.author && <span>{read.author}</span>}
                  {read.publication && <span>{read.publication}</span>}
                  {read.date && (
                    <time dateTime={read.date}>
                      {formatContentDate(read.date, {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </time>
                  )}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default Reads;
